import ChromeMessage from './ChromeMessage.vue'
export default ChromeMessage

const MIN_CHROME_VERSION = 79
export { MIN_CHROME_VERSION }
